<template lang="html">

  <section class="productos animation">

    <h2 class="container title -woline" v-html="$t('productos_banner.title')"></h2>
    
    <div class="listado-productos row-center">

      <template v-for="(el,key) in $t('productos')">

        <article class="producto-el row-center" :data="key">

          <router-link :to="$t(`enlaces.${el.slug}`)" class="enlace-cover"></router-link>

          <h3 class="title">{{el.nombre}}</h3>

        </article>

      </template>

    </div>

  </section>

</template>

<script lang="js">
  export default  {
    name: 'productos-banner',
  }
</script>

<style scoped lang="scss">

  @import "@/assets/css/colors.scss";

  .productos{
    position: relative;
    
    background: $mud-brown;
    > .title{
      color: $plum;
      position: absolute;
      top: -33px;
      margin-bottom: 0;
      height: 34px;
      transform: translateY(50px);
      transition: 1s;
      opacity: 0;
      transition-delay: 2s;
    }
  }

  .finca-view .productos > .title{
    color: rgba(255, 255, 255, 0.5);
    background-color:#4d161f;
    top:-50px;
    height: 100px;
    padding-top:22px;
    text-align:right;
    font-size: 28px;
    
  }

  .listado-productos{
    overflow: hidden;
  }

  .producto-el{
    width: 20%;
    height: 20vw;
    position: relative;
    transform: translateY(100%);
    transition: 1s;
    opacity: 0;

    &:nth-child(2n){
      transform: translateY(-100%);
    }

    .enlace-cover{
      transition: 1s;
      background: rgba(0,0,0,.7);
    }

    .title{
      color: white;
      text-align: center;
      transform: translateY(-80px);
      opacity: 0;
      transition: .5s;
    }

    .title::before{
      width: 100px;
      left: 50%;
      transform: translateX(-50%) scaleX(0);
      transition: .5s;
    }

  }


  @for $i from 1 through 5{
    .producto-el:nth-child(#{$i}){
      transition-delay: #{$i / 5 + .4}s;
    }
  }

  @for $i from 1 through 5{
    .producto-el:nth-child(#{$i}) .enlace-cover,
    .producto-el:nth-child(#{$i}) .title{
      transition-delay: #{$i / 5 + 1.5}s;
    }
  }

  .producto-el:hover .title{
    transform: translateY(0);
  }

  .producto-el:hover .title::before{
    transform: translateX(-50%) scaleX(1);
  }

  .producto-el[data="vino"]{
    background: url(/static/img/banner-vino.jpg) center/cover no-repeat;
  }

  .producto-el[data="aceite"]{
    background: url(/static/img/banner-aceite.jpg) center/cover no-repeat;
  }

  .producto-el[data="azafran"]{
    background: url(/static/img/banner-azafran.jpg) center/cover no-repeat;
  }

  .producto-el[data="cava"]{
    background: url(/static/img/banner-cava.jpg) center/cover no-repeat;
  }

 .producto-el[data="queso"]{
    background: url(/static/img/banner-queso.jpg) center/cover no-repeat;
  }

  .ficha-producto .productos{
    margin-top: 0; 
    > .title{
      color: white;
    }
  }

  .productos.launched{
    .title{
      opacity: 1;
      transform: translateY(0);
    }

    .producto-el{
      transform: translateY(0);
      opacity: 1;
      .enlace-cover{
        background: transparent;
      }
      .title{
        transform: translateY(20px);
        opacity: 1;
      }
    }
  }

  @media screen and (max-width: 900px){

    .producto-el{
      width: 100%;
      height: 115px;
    }
  }
  
    @media screen and (max-width: 700px){

      .productos{
        margin-top: 50px;
        > .title{
          top: -20px;
        }
      }

    .producto-el{
      width: 100%;
    }


  }


  @media screen and (max-width: 500px){
    .productos > .title{
      top: -22px;
    }
  }



</style>



// WEBPACK FOOTER //
// src/components/parts/productos-banner.vue